// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__28vH1","cell":"ColumnAccessor_cell__12sFS","firstCellAccent":"ColumnAccessor_firstCellAccent__1_PvH"};